import moment from 'moment';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { actions } from '../reducers';

export const roundDate = date =>
  moment(date).hour(0).minute(0).second(0).millisecond(0);

export const formatDate = date => moment(date).format();

export const isSameDate = (dateA, dateB) =>
  roundDate(dateA).isSame(roundDate(dateB));

export const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

export const withPage = connect(state => ({
  page: state.pages.page,
  previousPage: state.pages.previousPage
}));

export const withEvent = compose(
  connect((state, { eventId }) => ({ event: state.schedule.events[eventId] }), {
    setEventDate: actions.schedule.setEventDate
  }),
  withProps(props => ({
    setEventDate: date =>
      props.setEventDate({
        type: props.selectingType,
        id: props.eventId,
        date
      })
  }))
);



// WEBPACK FOOTER //
// ./src/components/util.js